module.exports = __webpack_public_path__ + "img/cpRole.eacbed0f.svg";